<template>
  <q-page class="main">
    <common-form :action="$route('rule.store')">
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Maak een nieuwe richtlijn aan</h1>
          <rule-form :rule="rule"
                     :themes="themes"
                     :phases="phases"
                     :categories="categories"
                     :subcategories="subcategories"
                     :ruleVersion="ruleVersion"
                     :editableCategories="editableCategories"/>
          <div v-if="!$isDesktop" class="row justify-end q-pt-lg">
            <accent-button label="Opslaan" type="submit" />
          </div>
        </q-card-section>
        <template v-if="$isDesktop">
          <q-separator />
          <q-card-actions align="right" class="q-pa-md">
            <accent-button label="Opslaan" type="submit"/>
          </q-card-actions>
        </template>
      </q-card>
      <sticky-top-bar />
      <sticky-bottom-bar v-if="!$isDesktop" >
        <common-fab icon="done" label="Opslaan" type="submit"/>
      </sticky-bottom-bar>
    </common-form>
  </q-page>
</template>

<script>
import RuleForm from './RuleForm'
import ChipList from '~HIOR/components/lists/ChipList'
import DocumentList from '~HIOR/components/lists/DocumentList'

export default {
  props: {
    phases: {
      type: Object,
      default: null,
    },
    categories: {
      type: Object,
      default: null,
    },
    subcategories: {
      type: Object,
      default: null,
    },
    themes: {
      type: Array,
      default: null,
    },
    editableCategories: {
      type: Array,
      default: null,
    },
  },
  components: {
    ChipList,
    DocumentList,
    RuleForm,
  },
  data () {
    return {
      rule: {
        code: '',
        type: null,
        leading_category_id: null,
      },
      ruleVersion: {
        summary: '',
        description: '',
        motivation: '',
        phases: [],
        categories: [],
        subcategories: [],
        themes: [],
        links: [],
        maps: [],
      },
    }
  },
}
</script>
